export default "__VITE_ASSET__DwJxTW02__"